<template>
  <div class="tabs-container">
    <div class="tabs">
      <div
        :class="['tab', { active: isWidgetSettingTab }]"
        @click.prevent="toWidgetSettingTab(true)"
      >
        <span class="material-icons-outlined align-middle">tune</span>
        <span class="text">Parameters</span>
      </div>
      <div
        :class="['tab', { active: !isWidgetSettingTab }]"
        @click.prevent="toWidgetSettingTab(false)"
      >
        <span class="material-icons-outlined align-middle">layers</span>
        <span class="text">Layers</span>
      </div>
    </div>

    <div class="widget-panel scrollbar" v-show="isWidgetSettingTab">
      <TemplatePanel v-if="showTemplatePanel" v-model="template" />

      <component
        v-if="!showTemplatePanel"
        :key="widgetId"
        :is="widgetPanel"
        :value="widget"
      ></component>
    </div>

    <LayerPanel v-show="!isWidgetSettingTab" />
  </div>
</template>

<script>
  import { mapMutations, mapState } from 'vuex';

  import ButtonWidgetPanel from '@/components/templates/editor/settingPanel/ButtonWidgetPanel';
  import ClockWidgetPanel from '@/components/templates/editor/settingPanel/ClockWidgetPanel';
  import ImageWidgetPanel from '@/components/templates/editor/settingPanel/ImageWidgetPanel';
  import TemplatePanel from '@/components/templates/editor/settingPanel/TemplatePanel';
  import LayerPanel from '@/components/templates/editor/LayerPanel';
  import LayerWidgetPanel from '@/components/templates/editor/settingPanel/LayerWidgetPanel';
  import TextWidgetPanel from '@/components/templates/editor/settingPanel/TextWidgetPanel';
  import AppWidgetPanel from '@/components/templates/editor/settingPanel/AppWidgetPanel';
  import VideoWidgetPanel from '@/components/templates/editor/settingPanel/VideoWidgetPanel';
  import PdfWidgetPanel from '@/components/templates/editor/settingPanel/PdfWidgetPanel';
  import RichTextWidgetPanel from '@/components/templates/editor/settingPanel/RichTextWidgetPanel';
  import AudioWidgetPanel from '@/components/templates/editor/settingPanel/AudioWidgetPanel';
  import TenantWidgetPanel from '@/components/templates/editor/settingPanel/TenantsWidgetPanel';
  import TrafiklabWidgetPanel from '@/components/templates/editor/settingPanel/TrafiklabWidgetPanel';
  import WeatherWidgetPanel from '@/components/templates/editor/settingPanel/WeatherWidgetPanel';
  import RSSWidgetPanel from '@/components/templates/editor/settingPanel/RssWidgetPanel.vue';
  import LinkWidgetPanel from '@/components/templates/editor/settingPanel/LinkWidgetPanel';
  import TableWidgetPanel from '@/components/templates/editor/settingPanel/TableWidgetPanel.vue';
  import TimeWidgetPanel from '@/components/templates/editor/settingPanel/TimeWidgetPanel.vue';
  import DateWidgetPanel from '@/components/templates/editor/settingPanel/DateWidgetPanel.vue';

  import { WIDGET_TYPES } from '@/models/layoutDesigner';

  import { TEMPLATE_DESIGNER_TO_SETTING_TAB } from '@/store/actions/templateDesigner';

  const panels = {
    [WIDGET_TYPES.LAYER]: LayerWidgetPanel,
    [WIDGET_TYPES.BUTTON]: ButtonWidgetPanel,
    [WIDGET_TYPES.TEXT]: TextWidgetPanel,
    [WIDGET_TYPES.CLOCK]: ClockWidgetPanel,
    [WIDGET_TYPES.IMAGE]: ImageWidgetPanel,
    [WIDGET_TYPES.APP]: AppWidgetPanel,
    [WIDGET_TYPES.VIDEO]: VideoWidgetPanel,
    [WIDGET_TYPES.AUDIO]: AudioWidgetPanel,
    [WIDGET_TYPES.PDF]: PdfWidgetPanel,
    [WIDGET_TYPES.RICH_TEXT]: RichTextWidgetPanel,
    [WIDGET_TYPES.TENANTS]: TenantWidgetPanel,
    [WIDGET_TYPES.WEATHERV2]: WeatherWidgetPanel,
    [WIDGET_TYPES.RSSV2]: RSSWidgetPanel,
    [WIDGET_TYPES.TRAFIKLABV2]: TrafiklabWidgetPanel,
    [WIDGET_TYPES.LINK]: LinkWidgetPanel,
    [WIDGET_TYPES.TABLEV2]: TableWidgetPanel,
    [WIDGET_TYPES.TIME]: TimeWidgetPanel,
    [WIDGET_TYPES.DATE]: DateWidgetPanel,
  };

  export default {
    name: 'Tabs',

    components: {
      LayerPanel,
      TemplatePanel,
    },

    props: {
      widget: Object,
      template: Object,
    },

    computed: {
      ...mapState({
        isWidgetSettingTab: (state) => state.templateDesigner.isWidgetSettingTab,
      }),

      widgetPanel() {
        if (this.widget) {
          return panels[this.widget.object.type || WIDGET_TYPES.PLAYLIST];
        }
        return null;
      },

      widgetId() {
        return this.widget.object.item_id;
      },

      showTemplatePanel() {
        return this.widgetPanel === null;
      },
    },

    methods: {
      ...mapMutations({
        toWidgetSettingTab: TEMPLATE_DESIGNER_TO_SETTING_TAB,
      }),
    },
  };
</script>

<style lang="scss" scoped>
  .tabs-container {
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .tabs {
    display: flex;
    margin-bottom: 16px;

    .tab {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      flex: 1;
      border-bottom: 2px solid #f0f0f0;
      padding: 8px 5px;
      transition: border-color 200ms ease-in-out;
      color: #6a6b6a;
      cursor: pointer;

      &:hover {
        border-color: #d6d6d6;
        color: #555555;
      }
      &.active {
        border-color: #e3003a;
        color: #151515;
      }

      .text {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: inherit;
      }
    }
  }

  .widget-panel {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    margin-right: 0px;
  }
</style>
